import { call, restService } from './apiHelpers';

const multipart = (payload) => {
  const form = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) form.append(key, value);
  });
  return form;
};

export const driverService = {
  ...restService('drivers'),
  getForActor: (_, filters) => call('get', 'drivers/', null, filters),
  searchCandidates: (type, query) =>
    call('get', 'drivers/candidates/', null, { type, search: query }),
  createForActor: (payload) => call('post', 'drivers/', multipart(payload)),
  updateForActor: (id, payload) => call('patch', `drivers/${id}/`, multipart(payload)),
  review: (id, decision, note) =>
    call('post', `drivers/${id}/review/`, { decision, note }),
  assignVehicle: (id, vehicleId) =>
    call('post', `drivers/${id}/assign-vehicle/`, { vehicle_id: vehicleId }),
};
